import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { addMessage } from "../../redux/slices/userMessageSlice";
import "devextreme/dist/css/dx.light.css";
import { Popup } from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import "./NewCatalogModalView.css";

interface IProps {
  entity?: any;
  open: boolean;
  onClose: (result: boolean) => void;
  id?: string;
  clonedObject?: any;
  searchText?: string;
  setSearchText?: React.Dispatch<React.SetStateAction<string>>;
  setSelectedItem?: React.Dispatch<any>;
  isDetailGroupViewOpen?: boolean;
}

export interface INewCatalogModalViewContextProps {
  saveHandler: (newModel: any) => Promise<void>;
  closeHandler: () => void;
}

export const NewCatalogModalViewContext =
  React.createContext<INewCatalogModalViewContextProps>({
    saveHandler: async () => {},
    closeHandler: () => {},
  });
export const NewCatalogModalView = ({
  id,
  entity,
  open,
  onClose,
  clonedObject,
  setSearchText,
  setSelectedItem,
  isDetailGroupViewOpen,
}: IProps) => {
  const [model, setModel] = useState<any>(null);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFailure, setIsFailure] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const [isPopupVisible, setIsPopupVisible] = useState(true);

  const onHiding = () => {
    setIsPopupVisible(false);
  };

  // const renderTitle = () => {
  //   return (

  //   );
  // };

  const dispatch = useDispatch();

  const loadModel = async () => {
    if (!id) {
      setModel(entity.getEmptyModel());
      return;
    }
    if (clonedObject) {
      setModel({ ...clonedObject, id: undefined });
      return;
    }

    try {
      setIsLoading(true);
      setIsFailure(false);
      setErrorMessage(null);

      const dataService = entity.getDataService();
      setModel(await dataService.Get(id));
    } catch (e: any) {
      setIsFailure(true);
      setErrorMessage(e.message);
      toast.error(e.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadModel();
  }, []);

  const handleSave = async (newModel: any) => {
    setModel(newModel);

    const dataService = entity.getDataService();
    let response;
    try {
      setIsLoading(true);
      setIsFailure(false);
      setErrorMessage(null);
      if (id && !clonedObject) {
        await dataService.Update(newModel);
      } else {
        response = await dataService.Create(newModel);
      }
    } catch (e: any) {
      setIsFailure(true);
      setErrorMessage(e.message);
      toast.error(e.message);
    } finally {
      setIsLoading(false);
    }

    dispatch(
      addMessage({
        message: "Saved successfully",
        type: "success",
        date: new Date(),
        markedAsRead: false,
      })
    );

    if (setSearchText) {
      setSearchText(newModel.name);
    }

    if (setSelectedItem) {
      setSelectedItem(response || newModel);
    }

    onClose(true);
  };

  function handleClose() {
    onClose(false);
  }

  const modelUpdated = (newModel: any) => {
    setModel(newModel);
  };

  return (
    <>
      <Popup
        visible={isPopupVisible}
        onHiding={onHiding}
        showCloseButton={false}
        showTitle={true}
        resizeEnabled={true}
        title={entity.title}
        dragEnabled={true}
        hideOnOutsideClick={true}
        onHidden={handleClose}
        dragOutsideBoundary={true}
      >
        <ScrollView>
          <div className="mt-3">
            <NewCatalogModalViewContext.Provider
              value={{
                saveHandler: handleSave,
                closeHandler: handleClose,
              }}
            >
              {!isDetailGroupViewOpen ? (
                <>{entity.getDetailViewComponent(model, modelUpdated)}</>
              ) : (
                <>{entity.getGroupViewComponent(model, modelUpdated)}</>
              )}
            </NewCatalogModalViewContext.Provider>
          </div>
        </ScrollView>
      </Popup>
    </>
  );
};
